export const applyFilters = (data, filters) => {
  return data.filter(row => {
    return Object.entries(filters).every(([key, filterValue]) => {
      if (!filterValue) return true;
      
      const cellValue = row[key];
      
      if (typeof filterValue === 'object') {
        return applyRangeFilter(cellValue, filterValue);
      } else {
        return String(cellValue).toLowerCase().includes(filterValue.toLowerCase());
      }
    });
  });
};

const applyRangeFilter = (value, range) => {
  const numValue = parseFloat(value);
  if (range.min && numValue < range.min) return false;
  if (range.max && numValue > range.max) return false;
  return true;
};
